import React, { createContext, useMemo } from 'react';

export interface ChainIdContext {
  chainId: number;
}

interface ChainProps {
  children?: React.ReactNode;
}

export const Context = createContext<ChainIdContext>({ chainId: 2222 });

// Kava only - no chain switching
export const ChainIdProvider: React.FC<ChainProps> = ({ children }) => {
  const value = useMemo(() => ({ chainId: 2222 }), []); // Kava only

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
